import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const FilterColumnsMeta: ComponentMeta = {
  componentName: "FilterColumns",
  package: "@mijadesign/web",
  title: "筛选表单",
  description: "基于 @mijadesign/web 的筛选表单组件",
  category: ComponentCategory.FORM,
  visibleInComponentPanel: true,
  icon: "FilterOutlined",
  canHaveChildren: false,
  eventSources: [
    {
      name: "filterColumns.submit",
      label: "提交",
      trigger: "component",
    },
    {
      name: "filterColumns.reset",
      label: "重置",
      trigger: "component",
    },
    {
      name: "filterColumns.collapsed.change",
      label: "折叠状态变化",
      trigger: "component",
    },
  ],
  props: [
    {
      name: "options",
      label: "字段配置",
      // 使用字面量兜底，避免枚举运行时缓存导致的匹配失败
      type: PropType.FILTER_COLUMNS,
      group: "数据",
      defaultValue: [],
    },
    {
      name: "defaultCollapsed",
      label: "默认折叠",
      type: PropType.BOOLEAN,
      defaultValue: true,
      group: "基础",
    },
    {
      name: "collapsedLines",
      label: "收起行数",
      type: PropType.NUMBER,
      defaultValue: 1,
      min: 1,
      group: "布局",
    },
    {
      name: "submitText",
      label: "提交按钮文案",
      type: PropType.STRING,
      defaultValue: "查询",
      group: "基础",
    },
    {
      name: "resetText",
      label: "重置按钮文案",
      type: PropType.STRING,
      defaultValue: "重置",
      group: "基础",
    },
    {
      name: "singleLineLayout",
      label: "单行布局",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "布局",
    },
    {
      name: "labelWidth",
      label: "标签宽度",
      type: PropType.STRING,
      defaultValue: "auto",
      group: "布局",
    },
  ],
  defaultProps: {
    defaultCollapsed: true,
    collapsedLines: 1,
    submitText: "查询",
    resetText: "重置",
    singleLineLayout: false,
    labelWidth: "auto",
    options: [],
  },
  preview: [
    {
      title: "基础筛选",
      props: {
        options: [
          {
            title: "关键词",
            dataIndex: "keyword",
            valueType: "text",
          },
          {
            title: "状态",
            dataIndex: "status",
            valueType: "select",
            valueEnum: {
              open: { text: "开启" },
              closed: { text: "关闭" },
            },
          },
        ],
      },
    },
    {
      title: "单行筛选",
      props: {
        singleLineLayout: true,
        options: [
          {
            title: "名称",
            dataIndex: "name",
            valueType: "text",
          },
          {
            title: "创建时间",
            dataIndex: "createdAt",
            valueType: "dateRange",
          },
        ],
      },
    },
  ],
  docLinks: [
    {
      title: "FilterColumns 文档",
      url: "https://frontend.mishudata.com/uigallery/iframe.html?key=mijadesign-web/components/FilterColumns",
      source: "mijadesign",
    },
  ],
  npm: {
    package: "@mijadesign/web",
    exportName: "FilterColumns",
  },
  snippet: {
    componentName: "FilterColumns",
    package: "@mijadesign/web",
    props: {
      defaultCollapsed: true,
      collapsedLines: 1,
      submitText: "查询",
      resetText: "重置",
      options: [],
    },
  },
};
